/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export const UPDATE_SHOW_LOADING_MESSAGE = 'mbp-checkout/UPDATE_SHOW_LOADING_MESSAGE';
export const FLAGOFF_SHOW_LOADING_MESSAGE = 'mbp-checkout/FLAGOFF_SHOW_LOADING_MESSAGE';
export const UPDATE_LOADER_ID = 'mbp-checkout/UPDATE_LOADER_ID';
